import { render, staticRenderFns } from "./kllk-menu.vue?vue&type=template&id=22897c58&scoped=true&"
import script from "./kllk-menu.vue?vue&type=script&lang=js&"
export * from "./kllk-menu.vue?vue&type=script&lang=js&"
import style0 from "./kllk-menu.vue?vue&type=style&index=0&id=22897c58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22897c58",
  null
  
)

export default component.exports